import { type MyCollectible } from '../models';

export const getCollectibleSerialNumber = (collectible?: MyCollectible) =>
	collectible?.summary?.supplyPosition && collectible.summary?.totalSupply
		? `#${collectible.summary.supplyPosition}/${collectible.summary.totalSupply}`
		: '';
